import { useParams } from "react-router-dom";
import NewsCategoryPage from "./NewsCategoryPage";
import Newspage from "../Newspage";
import { showDatabaseSearch } from "config";

export default function SearchSourceSwitch() {
  const { source } = useParams();
  
  if (
    source === "categories" ||
    source === "rating" ||
    source === "partner-publishers" ||
    (showDatabaseSearch && source === "databases")
  ) {
    return <Newspage />;
  }
  return <NewsCategoryPage />;
}
